import { InfoCircleOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import {
  Col,
  DatePicker,
  Form,
  InputNumber,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";

const InvestorInformationForm = ({
  formData,
  updateFormData,
  form,
  onFinish,
  accountOptions,
  currencySymbol,
}) => {
  const handleValuesChange = (changedValues, allValues) => {
    updateFormData(allValues);
  };

  const handleFinish = (_data) => {
    onFinish(_data);
  };

  return (
    <div className="form-section">
      <h2 style={{ margin: 0, fontSize: "24px", marginBottom: "24px" }}>
        Investment Details
      </h2>

      <Form
        form={form}
        onFinish={handleFinish}
        layout="vertical"
        initialValues={formData}
        onValuesChange={handleValuesChange}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Investor Amount (Face Value)
                  <Tooltip title="Investor Amount">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"investorAmount"}
              rules={[
                {
                  required: true,
                  message: "Please enter amount",
                },
              ]}
            >
              <InputNumber
                style={{ height: "44px", width: "100%" }}
                placeholder="10,000,000,000"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                prefix={currencySymbol}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Purchase Price
                  <Tooltip title="Purchase Price">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"purchasePrice"}
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter purchase price",
              //   },
              // ]}
            >
              <InputNumber
                className="custom-input of-bold-disable-input"
                style={{ height: "44px", width: "100%" }}
                placeholder="10,000,000,000"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                prefix={currencySymbol}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Numbers of Units Purchased
                  <Tooltip title="Numbers of Units Purchased">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"numberOfUnitsPurchased"}
              rules={[
                {
                  required: true,
                  message: "Please enter number of units",
                },
              ]}
            >
              <InputNumber
                className="custom-input of-bold-disable-input"
                style={{ height: "44px", width: "100%" }}
                placeholder="20"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                suffix={"units"}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Total Consideration
                  <Tooltip title="Total Consideration">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"totalConsideration"}
              rules={[
                {
                  required: true,
                  message: "Please enter total consideration",
                },
              ]}
            >
              <InputNumber
                className="custom-input of-bold-disable-input"
                style={{ height: "44px", width: "100%" }}
                placeholder="10,000,000,000"
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
                prefix={currencySymbol}
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label="Settlement Date"
              name={"settlementDate"}
              style={{ flex: 1 }}
              rules={[
                {
                  required: true,
                  message: "Please select settlement date",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%", height: "44px" }}
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                className="bond-date-picker custom-input"
                format="DD/MM/YYYY"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Settlement Account Number
                  <Tooltip title="Settlement Account Number">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"settlementAccountNumber"}
              rules={[
                {
                  required: true,
                  message: "Please select account number",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select account number"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={accountOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default InvestorInformationForm;
